<template>
  <div>
    <ContentHeader path-set-type="append" />
    <div class="content-wrapper" v-loading="loading">
      <el-row class="content-right">
        <div class="search">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            class="searchForm"
          >
            <el-form-item class="item selcetItem" style="width:140px" prop="themeId">
                <el-select v-model="searchForm.themeId" :popper-append-to-body="false" placeholder="选择活动主题" filterable clearable  size="small">
                    <el-option
                    v-for="item in themeList"
                    :key="item.themeId"
                    :label="item.themeName"
                    :value="item.themeId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="item" prop="blockName">
              <el-input
                v-model="searchForm.blockName"
                placeholder="街区名称"
                size="small"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item class="item" prop="pocName">
              <el-input
                v-model="searchForm.pocName"
                placeholder="门店名称"
                size="small"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item class="item" prop="menuCode">
              <el-select v-model="searchForm.menuCode" placeholder="选择审批状态" size="small">
                <el-option
                v-for="item in menuMap"
                :key="item.key"
                :label="item.value"
                :value="item.key">
                </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item class="item" prop="selectBrand">
              <el-select
                v-model="searchForm.selectBrand"
                placeholder="选择品牌"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.brandId"
                  :label="item.brandName"
                  :value="item.abiBrandCode"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item class="item" prop="selectChannel">
              <el-select
                v-model="searchForm.selectChannel"
                placeholder="选择渠道"
                size="small"
                clearable
                filterable
              >
                <el-option
                  v-for="item in channelOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="item" prop="selectType">
              <el-select v-model="searchForm.selectType" placeholder="选择形式" size="small" filterable clearable>
                  <el-option
                  v-for="(key,value) in typeOptions"
                  :key="value"
                  :label="key"
                  :value="value">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="item" style="margin-right: 12px;" prop="selectLevel">
              <el-select v-model="searchForm.selectLevel" placeholder="选择级别" size="small" filterable clearable>
                  <el-option
                  v-for="(key,value) in levelOptions"
                  :key="value"
                  :label="key"
                  :value="value">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="item" prop="buCode">
                <el-select v-model="searchForm.buCode" placeholder="选择BU" filterable  size="small" clearable @change="cahngeBu()">
                    <el-option
                    v-for="item in buArr"
                    :key="item.orgCode"
                    :label="item.orgName"
                    :value="item.orgCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="item" style="width:140px" prop="regionCode">
                <el-select v-model="searchForm.regionCode" placeholder="选择销售大区" filterable  size="small" clearable>
                    <el-option
                    v-for="item in regionArr"
                    :key="item.orgCode"
                    :label="item.orgName"
                    :value="item.orgCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="item-btn">
              <el-button type="danger" size="small" @click="queryForm()"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button type="info" size="small" @click="resetForm()"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="item-select" v-if="cardData.length > 0">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div class="select-btn">
            <DialogPop
            @confirm="rejectAll"
            @getRejectaccount="getRejectaccount"
            :marLeft="true"
            :isReject="true"
            isType="1"
            btnText="批量退回"
            centerText="是否确认批量退回？"
            ></DialogPop>
            <DialogPop
              @confirm="agreeAll"
              isType="0"
              :marLeft="true"
              btnText="批量通过"
              centerText="是否确认批量通过？"
            >
            </DialogPop>
            <!-- <DialogPop
            @confirm="getAllthemelist"
            isType="0"
            btnText="全部通过"
            centerText="是否确认全部通过？"
            ></DialogPop> -->
          </div>
        </div>
        <div
          class="card-box "
          v-for="item in cardData"
          :key="item.activityId"
        >
        <div class="card-left"  >
          <div class="left-select">
            <el-checkbox v-model="item.isChecked" @change="changeItem(item.isChecked)"></el-checkbox>
          </div>
        </div>
        <div class="card-right card-item is-hover-shadow">
          <div class="left">
            <div class="left-top">
              <div class="top-name">
                <span v-if="item.blockName">{{item.blockName}}</span>
                <span v-else>{{item.gpActivityPocDTOList[0].pocName}}</span>
                <span style="margin-left: 5px;" v-if="item.blockName && item.gpActivityPocDTOList">：
                    <span>{{getToolsname(item,'saleName','、')}}</span>
                </span>
              </div>
              <div class="top-sign" v-if="item.themeInfoDTO">{{getBluename(item.themeInfoDTO.orgLevel)}}</div>
            </div>
            <div class="left-second">
              <div class="second-left">{{getToolsname(item,'activityName','-')}}</div>
                <div  class="second-right">
                    <span class="font-weight-bold">活动时间：</span>
                    <span>{{ getTime(item.themeInfoDTO.themeStartTime) }}</span>
                    <span>-</span>
                    <span>{{ getTime(item.themeInfoDTO.themeEndTime) }}</span>
              </div>
            </div>
            <div class="left-third">
              <span class="font-weight-bold">活动执行日期：</span>
              <span>{{ getToolsname(item,'timeName',' | ') }}</span>
            </div>
            <div class="left-second">
              <div class="second-left">
                <span class="font-weight-bold">区域：</span>
                <span>{{getToolsname(item,'areaName','-')}}</span>
              </div>
              <div class="second-right">
                <span class="font-weight-bold">提报要求售点：</span>
                <span>{{getToolsname(item,'typeName','-')}}</span>
            </div>
            </div>
          </div>
          <div class="right">
            <div class="right-top">待审批</div>
            <div class="right-center"></div>
            <div class="right-btn" >
              <div class="btn-right" v-if="searchForm.menuCode == '200'" @click="goApproval(item)">
                去审批
              </div>
              <div class="btn-right2" v-else @click="goApproval(item)">
                查看详情
              </div>
            </div>
          </div>
        </div>
        </div>
        <div v-if="cardData.length == 0">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <div v-if="cardData.length > 0" class="pagination" >
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="searchForm.total"
            :current-page="searchForm.page"
            :page-size="searchForm.pageSize"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ContentHeader from "@/components/content-header";
import gameplanApi from "../../api/gameplan";
import DialogPop from './components/dialog-pop.vue'

export default {
  name: "activityPhoto-approval",
  components: {
    ContentHeader,
    DialogPop
  },
  data() {
    return {
      searchForm: {
        themeId: '',
        blockName: '', // 街区名称
        pocName: '', // 门店名称
        selectChannel: '',// 选择渠道
        selectBrand: '', // 选择品牌
        searchStatus: "",
        menuCode: '200', //状态
        selectType: '', //形式
        selectLevel: '', //级别
        page: 1,
        pageSize: 10,
        total: 0,
        buCode: '',
        regionCode: '',
      },
      channelOptions: [], // 渠道下拉菜单
      brandOptions: [], // 品牌下拉菜单
      cardData: {},
      loading: true,
      loadingText: "",
      rejectAccount: '',
      checkAll: false,
      isIndeterminate: false,
      menuMap:[
        {key:'200',value:"待审批"},
        {key:'500',value:"已通过"},
        {key:'600',value:"已退回"},
      ],
      typeOptions: [],
      levelOptions: [],
      themeList: [],
      buArr:[],
      regionArr: [],
      allApprovelist: [],
      isAllapprove: false
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    gameplanLevel () {
      if (!this.userInfo) {
        return ''
      }
      const empLevel = this.userInfo.employeeLevel || 0

      if (empLevel === 90 || empLevel === 100) {
        return 'hq'
      }
      if (empLevel === 60 || empLevel === 70 || empLevel === 80) {
        return 'bu'
      }
      if (empLevel === 45 || empLevel === 50) {
        return 'region'
      }
      return ''
    },
  },
  watch: {},
  created() {
    this.searchForm.searchStatus = "01";
    this.init();
  },
  watch: {
    'searchForm.selectChannel': {
        handler (to, from) {
            this.getStyleMap()
            this.searchForm.selectType = ''
            this.searchForm.selectLevel = ''
        },
        deep:true,
        immediate:true
      },
    'searchForm.selectType': {
      handler (to, from) {
          this.getLevelMap()
          this.searchForm.selectLevel = ''
      },
      deep:true,
      immediate:true
    },
  },
  mounted() {},
  methods: {
    getChannel(themeChannels, sign) {
      if (themeChannels) {
        let arr = themeChannels.map((item) => {return item.themeChannelEnName}).join(sign);
        return arr;
      } else {
        return 'null'
      }
    },
    init() {
      this.getBuList()
      this.getSelectChannel();
      this.getThemeNamelist()
      this.getThemelist();
    },
    getToolsname (item,type,sign) {
      if (type == 'saleName') {
          let arr = item.gpActivityPocDTOList
          if (arr.length > 0) {
              let name = arr.map((item)=>{
                  return item.pocName
              }).join(sign)
              return name
          }
      } else if (type == 'activityName') {
          let arr = []
          if (item.themeInfoDTO) {
              arr.push(item.themeInfoDTO.themeName)
          }
          if (item.gpThemeDetailDTO.themeChannelName) {
            arr.push(item.gpThemeDetailDTO.themeChannelName.split('|')[1])
          }
          if (item.gpThemeDetailDTO.themeStyleName) {
              arr.push(item.gpThemeDetailDTO.themeStyleName)
          }
          if (item.gpThemeDetailDTO.themeLevelName) {
              arr.push(item.gpThemeDetailDTO.themeLevelName)
          }
          let name = arr.map((item)=>{
              return item
          }).join(sign)
          return name
      } else if (type == 'typeName') {
        if (!item.gpThemeDetailDTO) {
          return 'error'
        }
        let pocRelateType = item.gpThemeDetailDTO.pocRelateType
        if (pocRelateType == '0') {
            return '无售点'
        }else if (pocRelateType == '1') {
            return '单售点'
        } else if (pocRelateType == '2') {
            return '多售点'
        } else {
            return 'error'
        }
      } else if (type == 'timeName') {
          let arr = item.gpActivityTimeDTOList || []
          if (arr.length > 0) {
            let name = arr.map((item)=> {
              return item.activityTime
            }).join(sign)
            return name
          }else {
              return 'null'
          }
      } else if (type == 'areaName') {
        let arr = []
        if (item.buName) {
            arr.push(item.buName.split('|')[0])
        }
        if (item.regionName) {
            arr.push(item.regionName.split('|')[0])
        }
        let name = arr.map((item)=>{
            return item
        }).join(sign)
        return name
      } else {
          return 'error'
      }
    },
    getBluename (name) {
      if (name == 'region') {
          return 'Region'
      } else if (name == 'bu') {
          return 'BU'
      } else if (name == 'hq') {
          return 'HQ'
      } else {
          return 'error'
      }
    },
    cahngeBu () {
      if (!this.searchForm.buCode) {
        return this.searchForm.regionCode = ''
      }
      if (this.buArr.length > 0) {
          for (const item of this.buArr) {
              if (item.orgCode == this.searchForm.buCode) {
                  this.searchForm.buOrgId = item.orgId
                  this.getRegionList()
              }
          }
      }
    },
    async getBuList () {
        let params = {}
        const { data } = await gameplanApi.getBuList(params);
        if (data.resultCode === "0") {
            this.buArr = data.resultData.buList || [];
            this.cahngeBu()
        }
    },
    async getRegionList () {
        if (!this.searchForm.buOrgId) {
            return
        }
        let params = {
            buOrgId: this.searchForm.buOrgId
        }
        const { data } = await gameplanApi.getRegionList(params);
        if (data.resultCode === "0") {
            this.regionArr = data.resultData.regionList || [];
        }
    },
    async getStyleMap () {
      let params = {
          channelCode:this.searchForm.selectChannel
      }
      const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
      if (data.resultCode === "0") {
          this.typeOptions = data.resultData.themeStyleMap || {};
      }
    },
    async getLevelMap () {
      let params = {
          styleCode:this.searchForm.selectType
      }
      const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
      if (data.resultCode === "0") {
          this.levelOptions = data.resultData.themeLevelMap || {};
      }
    },
    //单选
    changeItem (item) {
      // console.log(item,'单选');
      // isShowsome 未全选  isShowall 全选  isShownone 全不选
      let isShowsome =  this.cardData.some(item=>{
          return item.isChecked == false
      })
      let isShowall =  this.cardData.every(item=>{
          return item.isChecked == true
      })
      let isShownone =  this.cardData.every(item=>{
          return item.isChecked == false
      })
      if (isShowall) {
          this.isIndeterminate = false
          this.checkAll = true
      } else if(isShownone) {
          this.isIndeterminate = false
          this.checkAll = false
      } else if(isShowsome) {
          this.isIndeterminate = true
          this.checkAll = false
      }
    },
    //全选
    handleCheckAllChange () {
      // isHavefasle 判断是否有至少一个勾选 isShowsome 未全选  isShowall 全选  isShownone 全不选
      let isHavefasle =  this.cardData.some(item=>{
          return item.isChecked == false
      })
      if (isHavefasle) {
          for (let item of this.cardData) {
              item.isChecked = true
          }
      } else {
          for (let item of this.cardData) {
              item.isChecked = !item.isChecked
          }
      }
      let isShowsome =  this.cardData.some(item=>{
          return item.isChecked == false
      })
      let isShowall =  this.cardData.every(item=>{
          return item.isChecked == true
      })
      let isShownone =  this.cardData.every(item=>{
          return item.isChecked == false
      })
      if (isShowall) {
          this.isIndeterminate = false
          this.checkAll = true
      } else if(isShownone) {
          this.isIndeterminate = false
          this.checkAll = false
      } else if(isShowsome) {
          this.isIndeterminate = true
          this.checkAll = false
      }
    },
    // 理由
    getRejectaccount (val) {
      this.rejectAccount = val
    },
    rejectAll () {
      let arr = []
      let arrCheck = []
      for (let item1 of this.cardData) {
        if (item1.isChecked == true) {
          arrCheck.push(item1)
          for (let item of item1.imageApprovalList) {
            if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
              arr.push({
                "imageApprovalId": item.imageApprovalId,
                "processAction": "03",
                'rejectReason':this.rejectAccount,
                'rejectPerson':this.userInfo.clientName,
              })
            }
          }
        }
      }
      if (arrCheck.length > 0) {
        this.allApprove(arr)
      } else {
        this.$message.warning("未勾选售点");
      }
      // console.log(arr,'arr-rejectAll');
    },
    agreeAll () {
      let arr = []
      let arrCheck = []
      for (let item1 of this.cardData) {
        if (item1.isChecked == true) {
          arrCheck.push(item1)
          for (let item of item1.imageApprovalList) {
            if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
              arr.push({
              "imageApprovalId": item.imageApprovalId,
              "processAction": "02"
              })
            }
          }
        }
      }
      // console.log(arr,'arr-agreeAll');
      if (arrCheck.length > 0) {
        this.allApprove(arr)
      } else {
        this.$message.warning("未勾选售点");
      }
    },
    // 全部通过
    allApprovego () {
      if (this.allApprovelist.length == 0) {
          return this.$message.warning('当前条件下没有待审批的数据')
      }
      let arr = []
      for (let item1 of this.allApprovelist) {
        for (let item of item1.imageApprovalList) {
          if ((this.gameplanLevel === 'region' && item.evidenceStatus === 200) || (this.gameplanLevel === 'bu' && item.evidenceStatus === 300) || (this.gameplanLevel === 'hq' && item.evidenceStatus === 400)) {
            arr.push({
            "imageApprovalId": item.imageApprovalId,
            "processAction": "02"
            })
          }
        }
      }
      // console.log(arr,'arr-allApprovego');
      this.isAllapprove = true
      this.allApprove(arr)
    },
    allApprove (params) {
      this.loading = true
      gameplanApi.submitImageApproval(params).then((res) => {
        this.loading = false
        if (res.data.resultCode === "0") {
          if (this.isAllapprove) {
            this.$message.success('全部通过成功');
          } else {
            if (params[0].processAction == "02") {
              this.$message.success("批量通过成功");
            } else if (params[0].processAction == "03") {
              this.$message.success("批量退回成功");
            }
          }
          this.getThemelist();
          this.isAllapprove = false
          this.rejectAccount = ''
        } else {
          console.log("error")
        }
      }).catch((err) => {
        this.loading = false
      })

    },
    getTime(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D;
      }
    },
    getThemeNamelist () {
        let params = {
          buCode:this.searchForm.buCode,
          regionCode:this.searchForm.regionCode,
          queryPhoto:'01'
        }
        gameplanApi.getApprovenameList(params).then(res=>{
            if (res.data.resultCode === '0') {
                this.themeList = res.data.resultData.themeNameList || []
            }
        })

    },
    getThemelist() {
      let params = {
        page: this.searchForm.page,
        pageSize: this.searchForm.pageSize,
        themeId:this.searchForm.themeId,
        themeChannelCode:this.searchForm.selectChannel,
        themeStyleCode:this.searchForm.selectType,
        themeLevelCode:this.searchForm.selectLevel,
        blockName:this.searchForm.blockName,
        pocName:this.searchForm.pocName,
        buCode:this.searchForm.buCode,
        regionCode:this.searchForm.regionCode,
        queryPhoto:'01'
      };
      this.loading = true;
      gameplanApi.getThemeApproveList(params).then((res) => {
        if (res.data.resultCode === "0") {
          let pageData = res.data.resultData.pageInfo;
          this.searchForm.page = Number(pageData.curPage);
          this.searchForm.total = Number(pageData.totalCounts);
          // this.themeList = res.data.resultData.themeNameList || []
          if (res.data.resultData.activityList == null) {
            this.cardData = [];
            this.loading = false;
            this.loadingText = "空数据";
          } else {
            let cardData = res.data.resultData.activityList;
            for (let item of cardData) {
              item.isChecked = false
            }
            this.cardData = cardData
            this.isIndeterminate = false
            this.checkAll = false
            this.loading = false;
            this.loadingText = "";
          }
        } else {
          console.log("接口error");
        }
      });
    },
    getAllthemelist () {
      let params = {
          themeId:this.searchForm.themeId,
          themeChannelCode:this.searchForm.selectChannel,
          themeStyleCode:this.searchForm.selectType,
          themeLevelCode:this.searchForm.selectLevel,
          blockName:this.searchForm.blockName,
          pocName:this.searchForm.pocName,
          buCode:this.searchForm.buCode,
          regionCode:this.searchForm.regionCode,
          queryPhoto:'01'
      }
      gameplanApi.getApprovenameList(params).then(res=>{
          if (res.data.resultCode === '0') {
              if (res.data.resultData.activityList == null) {
                  this.allApprovelist = []
              } else {
                  this.allApprovelist = res.data.resultData.activityList
              }
              this.allApprovego()
          }
      })
    },
    async getSelectChannel() {
      // name=gpThemeChannelMap&type=list或map
      let params = {
        name: "gpThemeChannelMap",
        type: "list",
      };
      let data = await gameplanApi.getGamepalnChannelquery(params);
      this.channelOptions = data.data.resultData.gpThemeChannelMap;
    },
    async getSelectBrand() {
      let data = await gameplanApi.getGamepalnBrandquery();
      this.brandOptions = data.data.resultData.btmpBrandDTOList;
    },
    // 搜索
    queryForm() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.searchForm.page = 1;
          this.getThemelist();
        } else {
          return false;
        }
      });
    },
    // 重置
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.searchForm.page = 1;
      this.getThemelist();
    },
    // 去审批
    goApproval(item) {
      this.$router.push({
        path: "/gameplan/activityPhoto-salePlace-detail",
        query: {
          themeId: item.themeId,
          activityId: item.activityId
        },
      });
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getThemelist();
    },
  },
};
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }

    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        padding: 0 auto;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            margin: 0 auto;
            .searchForm {
                width: 100%;
                display: flex;
                // justify-content: center;
                margin-left: 30px;

                .item {
                  width:110px;
                  ::v-deep .el-input__inner {
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                  }
                }
                .item-btn {
                    margin-left: 20px;
                }
                .selcetItem{
                    ::v-deep .el-select-dropdown__wrap {
                        max-height: 274px;
                        max-width: 200px;
                    }
                }
            }
        }
        .item-select {
          line-height: 30px;
          height: 30px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
              color: #cd1231;
          }
          .select-btn {
              display: flex;
              justify-content: flex-end;
              margin: auto;
              margin-right: 10px;
          }
        }
        .card-box {
          border-radius: 10px;
          margin-bottom: 30px;
          font-size: 14px;
          text-align: left;
          color: #101010;
          display: flex;
          .card-left {
            display: flex;
            flex-flow: column;
            justify-content: center;
            width: 40px;
            .left-select {
                margin-right: 15px;
            }
          }
          .card-right {
              flex: 1;
              display: flex;
              .left {
                  text-align: left;
                  color: #101010;
                  width: 90%;
                  .left-top {
                      // line-height: 27px;
                      // font-family: SourceHanSansSC-medium;
                      // font-size: 18px;
                      // font-weight: 600;
                      // word-wrap: break-word;
                      // word-break: normal;
                      // word-break: break-all;
                      padding-bottom: 10px;
                      font-size: 18px;
                      display: flex;
                      .top-name {
                          font-weight: 600;
                          word-wrap: break-word;
                          word-break: normal;
                          word-break: break-all;
                      }
                      .top-sign {
                          color: #FFFFFF;
                          background-color: #40A5EE;
                          margin-left: 10px;
                          padding: 0px 8px;
                          line-height: 18px;
                          height: 18px;
                          font-size: 14px;
                          margin-top: 2px;
                          font-weight: 600;
                      }
                  }
                  .left-second {
                      font-size: 14px;
                      display: flex;
                      padding-bottom: 5px;
                      padding-top: 5px;
                      .second-left {
                          margin-right: 25px;
                          line-height: 20px;
                          word-wrap: break-word;
                          word-break: normal;
                          word-break: break-all;
                      }
                      .second-right {
                          flex: 1;
                          min-width: 100px;
                          line-height: 20px;
                      }
                  }
                  .left-third {
                      font-size: 14px;
                      line-height: 20px;
                      padding-bottom: 5px;
                      padding-top: 5px;
                  }
              }
              .right {
                  flex: 1;
                  text-align: right;
                  .right-top {
                      line-height: 27px;
                      color: #CD1231 ;
                      font-size: 16px;
                      font-weight: 600;
                  }
                  .right-center {
                      margin-top: 26px;
                      height: 20px;
                      line-height: 20px;
                  }
                  .right-btn {
                      margin-top: 6px;
                      display: flex;
                      justify-content: flex-end;
                      font-size: 12px;
                      text-align: center;
                      height: 30px;
                      line-height: 30px;
                      .btn-right {
                        border: 0px solid #CD1231;
                        width: 80px;
                        border-radius: 4px;
                        background-color: #cd1231;
                        color: #ffffff;
                        cursor: pointer;
                      }
                      .btn-right2 {
                        border: 1px solid #CD1231;
                        width: 80px;
                        border-radius: 4px;
                        background-color: #ffffff;
                        color: #CD1231;
                        cursor: pointer;
                      }
                  }
              }
          }
          .card-item{
              background-color: #FFFFFF;
              border-radius: 10px;
              padding: 10px 20px;
              font-size: 14px;
              text-align: left;
              color: #101010;
          }
        }
        .pagination {
            position: relative;
            bottom: 0;
            text-align: center;
        }
      }
    }
</style>
